import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
// import NavBar_v03Responsive from './NavBar_v03a_Responsive_component';
import FAQ_Component_MASTER_v02_WithSUB from "./FAQ_Component_MASTER_v02_WithSUB";
import { IFAQDataDoc_v2_WithSUB } from "../../App_v01_Interfaces";
import { faqData } from '@/xDUIInsurance/App_v01_DUIInsurance_ConfigData';
interface AppConfigProps{
  faqDataDocument: IFAQDataDoc_v2_WithSUB;
}


const FAQs_Page_v01_MASTER_WithSUB: React.FC<AppConfigProps> = ({faqDataDocument}) => {
    return (
        <>
        {/* <Navbar_v01 appConfig={appConfig}></Navbar_v01> */}
        {/* <NavBar_v03Responsive appConfig={appConfig} /> */}
        <FAQ_Component_MASTER_v02_WithSUB faqDataDocument={faqDataDocument}></FAQ_Component_MASTER_v02_WithSUB>
        </>
    )
}

// const FAQs_Page_v01_vending_original: React.FC<AppConfigProps> = ({appConfig}) => {

//   return (
//     <>
//     {/* <NavBar_v03Responsive appConfig={appConfig}/> */}
//     <div className="container py-5">
//           <h2 className="mb-4 text-center"><i className="bi bi-question-circle-fill me-2"></i>Frequently Asked Questions</h2>
    
//           <div className="accordion" id="faqAccordion">
    
//             {/* General Questions */}
//             <div className="accordion-item">
//               <h2 className="accordion-header" id="headingGeneral">
//                 <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseGeneral" aria-expanded="true" aria-controls="collapseGeneral">
//                   <i className="bi bi-cup-straw me-2"></i>General Questions
//                 </button>
//               </h2>
//               <div id="collapseGeneral" className="accordion-collapse collapse show" aria-labelledby="headingGeneral" data-bs-parent="#faqAccordion">
//                 <div className="accordion-body">
//                   <ul>
//                     <li><strong>What types of products do your vending machines offer?</strong><br /> Snacks, drinks, healthy and customizable options.</li>
//                     <li><strong>Are your machines ADA-compliant and modern?</strong><br /> Yes, with cashless payments and real-time monitoring.</li>
//                     <li><strong>Do you offer healthy or specialty vending options?</strong><br /> Yes, including organic, gluten-free, and keto choices.</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
    
//             {/* Business Owners */}
//             <div className="accordion-item">
//               <h2 className="accordion-header" id="headingBusiness">
//                 <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBusiness" aria-expanded="false" aria-controls="collapseBusiness">
//                   <i className="bi bi-building me-2"></i>For Business Owners & Property Managers
//                 </button>
//               </h2>
//               <div id="collapseBusiness" className="accordion-collapse collapse" aria-labelledby="headingBusiness" data-bs-parent="#faqAccordion">
//                 <div className="accordion-body">
//                   <ul>
//                     <li><strong>What does it cost to install a vending machine?</strong><br /> It's free! We handle delivery, installation, and service.</li>
//                     <li><strong>How do I qualify?</strong><br /> We evaluate your site—high-traffic areas are ideal.</li>
//                     <li><strong>Who maintains the machines?</strong><br /> We do! Maintenance, repairs, and refills are included.</li>
//                     <li><strong>Do I receive a commission?</strong><br /> Yes, most locations earn a percentage of sales.</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
    
//             {/* Service & Support */}
//             <div className="accordion-item">
//               <h2 className="accordion-header" id="headingService">
//                 <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseService" aria-expanded="false" aria-controls="collapseService">
//                   <i className="bi bi-tools me-2"></i>Service & Support
//                 </button>
//               </h2>
//               <div id="collapseService" className="accordion-collapse collapse" aria-labelledby="headingService" data-bs-parent="#faqAccordion">
//                 <div className="accordion-body">
//                   <ul>
//                     <li><strong>What if the machine breaks?</strong><br /> Contact us—we resolve most issues in 24 hours.</li>
//                     <li><strong>What if someone loses money?</strong><br /> We offer full refunds via phone or online form.</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
    
//             {/* Entrepreneurs */}
//             <div className="accordion-item">
//               <h2 className="accordion-header" id="headingEntrepreneurs">
//                 <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEntrepreneurs" aria-expanded="false" aria-controls="collapseEntrepreneurs">
//                   <i className="bi bi-briefcase me-2"></i>For Vending Entrepreneurs
//                 </button>
//               </h2>
//               <div id="collapseEntrepreneurs" className="accordion-collapse collapse" aria-labelledby="headingEntrepreneurs" data-bs-parent="#faqAccordion">
//                 <div className="accordion-body">
//                   <ul>
//                     <li><strong>Do you sell or lease machines?</strong><br /> Yes, with support and training for new owners.</li>
//                     <li><strong>Do you provide locations?</strong><br /> Yes, through our placement services or partnerships.</li>
//                     <li><strong>Can I brand the machines?</strong><br /> Yes, we offer white-label and co-branded options.</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
    
//             {/* Contact */}
//             <div className="accordion-item">
//               <h2 className="accordion-header" id="headingContact">
//                 <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseContact" aria-expanded="false" aria-controls="collapseContact">
//                   <i className="bi bi-envelope-paper-heart me-2"></i>Still Have Questions?
//                 </button>
//               </h2>
//               <div id="collapseContact" className="accordion-collapse collapse" aria-labelledby="headingContact" data-bs-parent="#faqAccordion">
//                 <div className="accordion-body">
//                   <p>Contact us using the form on our website, call <strong>{appConfig.companyMainPhone}</strong>, or email <strong>{appConfig.infoeMail}</strong>. We're happy to help!</p>
//                 </div>
//               </div>
//             </div>
    
//           </div>
//         </div>
//         </>
//     )
// }; //end;FAQs_Page_v01

export default FAQs_Page_v01_MASTER_WithSUB;



// import React from 'react';
// import Navbar_v01 from '../components/Navbar_v01';

// const FAQ_v01: React.FC = () => {
//   return (
//     <>
//       <Navbar_v01 />
//       <div className='container mt-5'>
//         <h2>FAQ_v01</h2>
//         <p>Welcome to the FAQ_v01 page of Cost Crusher Insurance.</p>
//       </div>
//     </>
//   );
// };

// export default FAQ_v01;
